import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENTID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANTID}`,
        redirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['User.Read'],
};

export const pca = new PublicClientApplication(msalConfig);

export async function initializeMsal() {
    try {
        await pca.initialize();
        console.log('MSAL inicializado com sucesso.');
    } catch (error) {
        console.error('Erro ao inicializar o MSAL:', error);
    }
}
